export default "__VITE_ASSET__7fab696f__"